import { History } from 'history';

import { IMenuOption } from '@evinced-private/ui-common';

import { RoutesHelper } from 'src/common/helpers/RoutesHelper';

import {
	BusinessUnitSubTab,
	BusinessUnitSubTabId,
	DashboardTab,
	DashboardTabId
} from '../types/DashboardTypes';

/**
 * Get tab configuration for a specific tab ID
 */
export const getDashboardTabConfig = (tabId: DashboardTabId): DashboardTab => {
	const tabConfigs: Record<DashboardTabId, DashboardTab> = {
		[DashboardTabId.DASHBOARD]: {
			id: DashboardTabId.DASHBOARD,
			title: 'Dashboard',
			path: RoutesHelper.getAccessibilityDashboardPath()
		},
		[DashboardTabId.BUSINESS_UNITS]: {
			id: DashboardTabId.BUSINESS_UNITS,
			title: 'Business Units',
			path: RoutesHelper.getBusinessUnitDashboardPath()
		}
	};

	return tabConfigs[tabId];
};

/**
 * Create tab options with navigation handlers
 */
export const createDashboardTabOptions = (history: History): IMenuOption[] => {
	return Object.values(DashboardTabId).map((tabId) => {
		const config = getDashboardTabConfig(tabId);
		return {
			id: tabId,
			title: config.title,
			onClick: () => history.push(config.path)
		};
	});
};

/**
 * Determine active tab from current pathname
 */
export const getActiveTabFromPath = (pathname: string): DashboardTabId => {
	if (pathname.startsWith(RoutesHelper.getBusinessUnitDashboardPath())) {
		return DashboardTabId.BUSINESS_UNITS;
	}
	return DashboardTabId.DASHBOARD;
};

/**
 * Get sub-tab configuration for a specific sub-tab ID
 */
export const getBusinessUnitSubTabConfig = (subTabId: BusinessUnitSubTabId): BusinessUnitSubTab => {
	const subTabConfigs: Record<BusinessUnitSubTabId, BusinessUnitSubTab> = {
		[BusinessUnitSubTabId.WEB_SDKS]: {
			id: BusinessUnitSubTabId.WEB_SDKS,
			title: 'Web SDKs'
		},
		[BusinessUnitSubTabId.WEB_FLOW_ANALYZER]: {
			id: BusinessUnitSubTabId.WEB_FLOW_ANALYZER,
			title: 'Web Flow Analyzer'
		}
	};

	return subTabConfigs[subTabId];
};

/**
 * Create sub-tab options for business unit page
 */
export const createBusinessUnitSubTabOptions = (): IMenuOption[] => {
	return Object.values(BusinessUnitSubTabId).map((subTabId) => {
		const config = getBusinessUnitSubTabConfig(subTabId);
		return {
			id: subTabId,
			title: config.title,
			// eslint-disable-next-line @typescript-eslint/no-empty-function
			onClick: () => {} // No navigation needed for sub-tabs
		};
	});
};
